 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBOOK__TEST from '@/components/ebook_-_test'
 import EBOOK__TEST1 from '@/components/ebook_-_test-1'
 import EBOOK__TEST2 from '@/components/ebook_-_test-2'
 import EBOOK__TEST3 from '@/components/ebook_-_test-3'
 import EBOOK__TEST4 from '@/components/ebook_-_test-4'
 import EBOOK__TEST6 from '@/components/ebook_-_test-6'
 import EBOOK__TEST8 from '@/components/ebook_-_test-8'
 import EBOOK__TEST9 from '@/components/ebook_-_test-9'
 import EBOOK__TEST12 from '@/components/ebook_-_test-12'
 import EBOOK__TEST13 from '@/components/ebook_-_test-13'
 import EBOOK__TEST17 from '@/components/ebook_-_test-17'
 import EBOOK__TEST20 from '@/components/ebook_-_test-20'
 import EBOOK__TEST23 from '@/components/ebook_-_test-23'
 import EBOOK__TEST24 from '@/components/ebook_-_test-24'
 import EBOOK__TEST28 from '@/components/ebook_-_test-28'
 import EBOOK__TEST32 from '@/components/ebook_-_test-32'
 import EBOOK__TEST36 from '@/components/ebook_-_test-36'
 import EBOOK__TEST40 from '@/components/ebook_-_test-40'
 import EBOOK__TEST44 from '@/components/ebook_-_test-44'
 import EBOOK__TEST48 from '@/components/ebook_-_test-48'
 import EBOOK__TEST52 from '@/components/ebook_-_test-52'
 import EBOOK__TEST56 from '@/components/ebook_-_test-56'
 import EBOOK__TEST61 from '@/components/ebook_-_test-61'
 import EBOOK__TEST65 from '@/components/ebook_-_test-65'
 import EBOOK__TEST69 from '@/components/ebook_-_test-69'
 import EBOOK__TEST73 from '@/components/ebook_-_test-73'
 import EBOOK__TEST77 from '@/components/ebook_-_test-77'
 import EBOOK__TEST80 from '@/components/ebook_-_test-80'
 import EBOOK__TEST83 from '@/components/ebook_-_test-83'
 import EBOOK__TEST87 from '@/components/ebook_-_test-87'
 import EBOOK__TEST88 from '@/components/ebook_-_test-88'
 import EBOOK__TEST90 from '@/components/ebook_-_test-90'
 import EBOOK__TEST94 from '@/components/ebook_-_test-94'
 import EBOOK__TEST98 from '@/components/ebook_-_test-98'
 import EBOOK__TEST102 from '@/components/ebook_-_test-102'
 import EBOOK__TEST105 from '@/components/ebook_-_test-105'
 import EBOOK__TEST109 from '@/components/ebook_-_test-109'
 import EBOOK__TEST112 from '@/components/ebook_-_test-112'
 import EBOOK__TEST116 from '@/components/ebook_-_test-116'
 import EBOOK__TEST119 from '@/components/ebook_-_test-119'
 import EBOOK__TEST122 from '@/components/ebook_-_test-122'
 import EBOOK__TEST126 from '@/components/ebook_-_test-126'
 import EBOOK__TEST129 from '@/components/ebook_-_test-129'
 import EBOOK__TEST130 from '@/components/ebook_-_test-130'
 import EBOOK__TEST134 from '@/components/ebook_-_test-134'
 import EBOOK__TEST137 from '@/components/ebook_-_test-137'
 import EBOOK__TEST140 from '@/components/ebook_-_test-140'
 import EBOOK__TEST141 from '@/components/ebook_-_test-141'
 import EBOOK__TEST144 from '@/components/ebook_-_test-144'
 import EBOOK__TEST147 from '@/components/ebook_-_test-147'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebook_-_test",
 			"name" : "ebook_-_test",
 			"component" : EBOOK__TEST
 		},
 		{
 			"path" : "/ebook_-_test-1",
 			"name" : "ebook_-_test-1",
 			"component" : EBOOK__TEST1
 		},
 		{
 			"path" : "/ebook_-_test-2",
 			"name" : "ebook_-_test-2",
 			"component" : EBOOK__TEST2
 		},
 		{
 			"path" : "/ebook_-_test-3",
 			"name" : "ebook_-_test-3",
 			"component" : EBOOK__TEST3
 		},
 		{
 			"path" : "/ebook_-_test-4",
 			"name" : "ebook_-_test-4",
 			"component" : EBOOK__TEST4
 		},
 		{
 			"path" : "/ebook_-_test-6",
 			"name" : "ebook_-_test-6",
 			"component" : EBOOK__TEST6
 		},
 		{
 			"path" : "/ebook_-_test-8",
 			"name" : "ebook_-_test-8",
 			"component" : EBOOK__TEST8
 		},
 		{
 			"path" : "/ebook_-_test-9",
 			"name" : "ebook_-_test-9",
 			"component" : EBOOK__TEST9
 		},
 		{
 			"path" : "/ebook_-_test-12",
 			"name" : "ebook_-_test-12",
 			"component" : EBOOK__TEST12
 		},
 		{
 			"path" : "/ebook_-_test-13",
 			"name" : "ebook_-_test-13",
 			"component" : EBOOK__TEST13
 		},
 		{
 			"path" : "/ebook_-_test-17",
 			"name" : "ebook_-_test-17",
 			"component" : EBOOK__TEST17
 		},
 		{
 			"path" : "/ebook_-_test-20",
 			"name" : "ebook_-_test-20",
 			"component" : EBOOK__TEST20
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js